import { useEffect, useState } from "react";
import { BasicTable, MASK_NUMBER, MASK_TEXT_NOWRAP } from "../../../../theme/Component/BasicTable";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _Product } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { SelectTaxSchemeCatalogWithAddedValue } from "./SelectTaxSchemeCatalogWithAddedValue";


interface Props {
    idProduct: number;
    onChange: Function;
}

export const TaxSchemaValuesForAddedValue = ({ idProduct, onChange }: Props) => {

    const { lista, setLista, bean, setBean, instance } = useDataBean(_Product);

    const [taxScheme, setTaxScheme] = useState<any>({});


    useEffect(() => {
        if (idProduct && taxScheme.IDTaxScheme)
            getLista()
    }, [idProduct, taxScheme.IDTaxScheme])

    const getLista = () => {
        instance.getTaxSchemaValuesForAddedValue(taxScheme.IDTaxScheme, idProduct).then(
            (rta: any) => {
                setLista(rta)
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDTaxSchemeValue', visible: true, mask: MASK_NUMBER },
        { title: 'Tipo de Impuesto', property: 'TaxSchemeName', visible: true, },
        { title: 'Valor', property: 'TaxValueName', visible: true, mask: MASK_TEXT_NOWRAP },
        { title: 'Tipo', property: 'ValueTypeName', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
    ]

    const setRowBean = (obj) => {
        setBean(obj);
        if (onChange) {
            onChange(obj)
        }
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <SelectTaxSchemeCatalogWithAddedValue onChange={(e) => { setTaxScheme(e) }} label="Tipos de Impuestos" />
            </div>
            <div className="col-md-12">
                <BasicTable head={head} body={lista} rowSet={setRowBean} />
            </div>
        </div >
    )
}



